import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const webPeduliOptions = [
  { label: "Peduli Sumatera", value: "sumatera" },
  { label: "Peduli Lansia", value: "lansia" },
  { label: "Peduli Yatim", value: "yatim" },
  { label: "Peduli Palestina", value: "palestina" },
  { label: "Peduli Sudan", value: "sudan" },
];

const VideoDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [videoData, setVideoData] = useState<any>(null);

  const [judul, setJudul] = useState("");
  const [webPeduli, setWebPeduli] = useState("");
  const [video, setVideo] = useState<File | null>(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  /* ================= FETCH DETAIL ================= */
  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/video/${id}`);

        const data = res.data.data ?? res.data;
        setVideoData(data);

        setJudul(data.judul);
        setWebPeduli(data.web_peduli);
      } catch (err) {
        Swal.fire("Gagal", "Gagal memuat data video", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id]);

  /* ================= UPDATE ================= */
  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    Swal.fire({
      title: "Menyimpan...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("web_peduli", webPeduli);
    if (video) formData.append("video", video);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/video/${id}?_method=PUT`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Video berhasil diperbarui",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => navigate("/dashboard/video"), 1500);
    } catch (err: any) {
      Swal.fire("Gagal", err?.response?.data?.message || "Gagal update video", "error");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    const confirm = await Swal.fire({
      title: "Yakin?",
      text: "Video akan dihapus permanen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      confirmButtonText: "Ya, hapus",
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({ title: "Menghapus...", didOpen: () => Swal.showLoading() });

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/video/${id}`, { headers: { Authorization: `Bearer ${token}` } });

      Swal.fire("Terhapus", "Video berhasil dihapus", "success");
      navigate("/dashboard/video");
    } catch (err: any) {
      Swal.fire("Gagal", err?.response?.data?.message || "Gagal menghapus video", "error");
    }
  };

  if (loading) return <div className="p-4">Memuat...</div>;
  if (!videoData) return <div className="p-4 text-red-500">Data tidak ditemukan</div>;

  return (
    <div className="p-4 max-w-3xl mx-auto bg-white rounded shadow">
      <Link to="/dashboard/video">
        <div className="flex items-center gap-3 mb-4 cursor-pointer">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Edit Video</h1>
        </div>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-4">
        {/* Judul */}
        <div>
          <label className="font-semibold">Judul</label>
          <input type="text" value={judul} onChange={(e) => setJudul(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        {/* Web Peduli */}
        <div>
          <label className="font-semibold">Web Peduli</label>
          <select value={webPeduli} onChange={(e) => setWebPeduli(e.target.value)} className="w-full border px-3 py-2 rounded bg-white">
            <option value="">-- Pilih Web Peduli --</option>
            {webPeduliOptions.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        {/* Video Upload */}
        <div>
          <label className="font-semibold">Ganti Video (Opsional)</label>
          <input type="file" accept="video/*" onChange={(e) => setVideo(e.target.files?.[0] || null)} className="w-full border px-3 py-2 rounded bg-white" />
        </div>

        {/* Preview */}
        {videoData.video_url && (
          <div>
            <label className="font-semibold block mb-1">Preview</label>
            <div onClick={() => setPreviewOpen(true)} className="w-40 h-24 rounded overflow-hidden border cursor-pointer relative group">
              <video src={videoData.video_url} className="w-full h-full object-cover" muted />
              <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">▶</div>
            </div>
          </div>
        )}

        {/* ACTION */}
        <div className="flex gap-3">
          <button type="submit" className="bg-orange-600 text-white px-4 py-2 rounded">
            Simpan Perubahan
          </button>

          <button type="button" onClick={handleDelete} className="bg-red-600 text-white px-4 py-2 rounded">
            Hapus
          </button>
        </div>
      </form>

      {/* MODAL PREVIEW */}
      {previewOpen && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
          <div className="bg-white rounded-xl p-4 max-w-3xl w-full relative">
            <button onClick={() => setPreviewOpen(false)} className="absolute top-2 right-3 text-xl">
              ✕
            </button>
            <video src={videoData.video_url} controls autoPlay className="w-full h-[100vh] rounded" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoDetail;
